const reducer = (state = "", action) => {
    if (action.type === 'setConstants') {
        return action.payload
    }
    return state;
}

export default reducer;